import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import FormInput from 'components/form/form-input'

import styles from 'components/form/form-style'
import { isInputWithError } from 'helpers/form'

class TextInput extends Component {
  prefixRef = elmt => {
    this.prefix = elmt
  }

  inputRef = elmt => {
    this.input = elmt
  }

  setInputPadding = () => {
    if (this.prefix) {
      this.input.style.paddingLeft = `${this.prefix.offsetWidth + 18 + 2}px`
    } else if (this.suffix) {
      this.input.style.paddingRight = `${this.prefix.offsetWidth + 18 + 2}px`
    }
  }

  componentDidUpdate() {
    this.setInputPadding()
  }

  componentDidMount() {
    this.setInputPadding()
  }

  render() {
    return (
      <TextInputView
        {...this.props}
        prefixRef={this.prefixRef}
        inputRef={this.inputRef}
        suffixRef={this.suffixRef}
      />
    )
  }
}

const TextInputView = props => {
  const classes = styles(props.theme)

  const inputClassNames = meta => {
    return classNames(
      classes.textInput,
      { [classes.inputWithError]: isInputWithError(meta) },
      { [classes.focusedInput]: meta.active },
      { [classes.creditCardInput]: props.type === 'creditCard' },
    )
  }

  const blockProps = {
    label: props.label,
    dynamicLabel: !props.prefix,
    placeholder: props.placeholder,
    className: props.blockClassName,
    errorDirection: props.errorDirection,
    hideErrorMessage: props.hideErrorMessage,
  }

  let { parse, format } = props

  if (props.name == 'email' && !parse && !format) {
    parse = value => value && value.trim(),
    format = value => (value ? value.trim() : "")
  }

  const fieldProps = {
    name: props.name,
    parse: parse,
    format: format
  }

  const inputProps = {
    type: props.type === 'creditCard' ? 'text' : props.type,
    ref: props.inputRef,
    placeholder: props.placeholder,
  }

  return (
    <Field {...fieldProps}>
      {({ input, meta }) => (
        <FormInput meta={meta} input={input} {...blockProps}>
          {props.prefix &&
            <span className={classes.inputPrefix} ref={props.prefixRef}>{props.prefix}</span>
          }
          <input {...input} {...inputProps} className={inputClassNames(meta)} />
          {props.children}
          {props.suffix &&
            <span className={classes.inputSuffix} ref={props.suffixRef}>{props.suffix}</span>
          }
        </FormInput>
      )}
    </Field>
  )
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  blockClassName: PropTypes.string,
  errorDirection: PropTypes.string,
  parse: PropTypes.func,
  format: PropTypes.func,
  hideErrorMessage: PropTypes.bool,
}

TextInput.defaultProps = {
  type: 'text'
}

export default withTheme(TextInput)
